import React from "react";
import { FaRegCalendarAlt } from "react-icons/fa";

const FieldInput = ({ type, value, placeholder, onChange, label }) => {
  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-2 py-1.5 bg-white rounded-md text-sm border border-gray-300 hover:border-blue-600 focus:ring-blue-500 focus:outline-none"
      />
      {type === "date" && (
        <FaRegCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-[#223688]" />
      )}
    </div>
  );
};

export default FieldInput;
